import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=67f4a8f6&"
import script from "./MenuItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports